/* Show deeplinks for mobile on play */
;
(function () {

    var $dl = $('.js-m-deeplinks-onplay');
    var $webvr = $('#webvr');
    if (!$dl.length || !$webvr.length) return false;

    if ($webvr.hasClass("vid--stretched")) {
        setFixed();
    } else {
        clearFixed();
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
                var attributeValue = $(mutation.target).prop(mutation.attributeName);

                if (attributeValue.includes('vid--stretched')) {
                    setFixed();
                } else {
                    clearFixed();
                }
            }
        });
    });

    observer.observe($webvr[0], {attributes: true});

    function setFixed() {
        $dl.css({
            position: "fixed",
            "z-index": 200,
            top: "8px",
            left: 0,
            width: "100%",
            height: "",
            "margin-top": 0
        });

        $dl.find('.m-deeplinks-2--label').css('color', '#fff');
    }

    function clearFixed() {
        $dl.css({
            position: "",
            "z-index": "",
            top: "",
            left: "",
            width: "",
            height: "60px",
            "margin-top": "",
            color: ""
        });

        $dl.find('.m-deeplinks-2--label').css('color', '')
    }
})();